import { render } from "./ChessboardMain.vue?vue&type=template&id=1a37a12e&scoped=true"
import script from "./ChessboardMain.vue?vue&type=script&lang=js"
export * from "./ChessboardMain.vue?vue&type=script&lang=js"

import "./ChessboardMain.vue?vue&type=style&index=0&id=1a37a12e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a37a12e"]])

export default __exports__